<template>
  <Invoices />
</template>

<script>
import Invoices from '@/components/Invoices'

export default {
  name: 'Invoiceview',
  components: {
    Invoices
  }
}
</script>
